<button
  class="bt-back btn btn-border-orange m-0"
  (click)="previousEnabled ? onClickPrevious() : null"
  [ngClass]="{ disabled: !previousEnabled, 'visibility-hidden': !previousShow }"
>
  <span class="fa mr-10" [ngClass]="buttonIcon"></span>
  {{ previousLabel }}
</button>

<button
  class="bt-go btn btn-full-orange m-0"
  (click)="nextEnabled ? onClickNext() : null"
  [ngClass]="{ disabled: !nextEnabled, 'visibility-hidden': !nextShow }"
>
  {{ nextLabel }}
  <span class="fa fa-arrow-right ml-10"></span>
</button>
